export const IconPidbir: {
  name: 'icon_pidbir-dd7785751911'
} = {
  name: 'icon_pidbir-dd7785751911'
}
